import React from "react";
import { useTranslation } from "react-i18next";

const ProductsSection = () => {
  const { t } = useTranslation();

  // Demo gallery list — replace with actual products source
const products = [
  { name: "EmiratesMade.Products.SmartSensors", img: "https://images.unsplash.com/photo-1518779578993-ec3579fee39f?q=80&w=800&auto=format&fit=crop", category: "tech" },
  { name: "EmiratesMade.Products.IndustrialRobotics", img: "https://images.unsplash.com/photo-1581091014534-6cda8fcfa68b?q=80&w=800&auto=format&fit=crop", category: "tech" },
  { name: "EmiratesMade.Products.AerospaceComponents", img: "https://images.unsplash.com/photo-1544829728-e5cb9eed92bc?q=80&w=800&auto=format&fit=crop", category: "tech" },
  { name: "EmiratesMade.Products.AIServices", img: "https://images.unsplash.com/photo-1551281044-8b89e82f1c6b?q=80&w=800&auto=format&fit=crop", category: "tech" },
  { name: "EmiratesMade.Products.ConsumerElectronics", img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?q=80&w=800&auto=format&fit=crop", category: "tech" },
  { name: "EmiratesMade.Products.DefenseSystems", img: "https://images.unsplash.com/photo-1566132125289-bce03b02f53d?q=80&w=800&auto=format&fit=crop", category: "tech" },
  { name: "EmiratesMade.Products.MedicalDevices", img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?q=80&w=800&auto=format&fit=crop", category: "health" },
  { name: "EmiratesMade.Products.AdvancedTextiles", img: "https://images.unsplash.com/photo-1551537482-f2075a1d41f2?q=80&w=800&auto=format&fit=crop", category: "materials" },
  { name: "EmiratesMade.Products.GreenMaterials", img: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?q=80&w=800&auto=format&fit=crop", category: "materials" },
  { name: "EmiratesMade.Products.SustainablePackaging", img: "https://images.unsplash.com/photo-1543364195-bfe6e4932397?q=80&w=800&auto=format&fit=crop", category: "materials" },
  { name: "EmiratesMade.Products.MobilitySolutions", img: "https://images.unsplash.com/photo-1518432031352-d6fc5c10da5a?q=80&w=800&auto=format&fit=crop", category: "mobility" },
  { name: "EmiratesMade.Products.FoodAndBeverage", img: "https://images.unsplash.com/photo-1542838132-92c53300491e?q=80&w=800&auto=format&fit=crop", category: "consumer" },
];

  const fallbackImg = "https://picsum.photos/seed/emirates-made/800/600";

  return (
    <section style={{ padding: "80px 10%", backgroundColor: "#fff" }} id="products">
      {/* Card wrapper with gradient header - mirrors PartnersSection */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          marginBottom: "40px",
        }}
      >
        {/* Gradient Header (Emirates theme) */}
        <div
          style={{
            background: "var(--uae-gradient)",
            color: "#fff",
            padding: "40px 60px",
          }}
        >
          <h2 style={{ fontSize: "22px", fontWeight: 700, marginBottom: 10 }}>
            {t("EmiratesMade.Products.title", { defaultValue: "Emirates Products" })}
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, opacity: 0.9 }}>
            {t("EmiratesMade.Products.text", {
              defaultValue:
                "Discover locally produced goods and services that meet national standards and embody innovation, sustainability, and pride.",
            })}
          </p>
        </div>

        {/* Modern lightning gallery under short description */}
        <style>{`
          .prod-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:16px;margin-top:18px}
          .prod-card{position:relative;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 10px 24px rgba(0,0,0,.08);transition:all .25s ease}
          .prod-media{height:150px;background:#f1f3f8}
          .prod-media img{width:100%;height:100%;object-fit:cover;display:block}
          .prod-name{padding:12px 14px;font-weight:700;color:#0a2750}
          .prod-card::after{content:"";position:absolute;inset:0;border-radius:16px;padding:1px;background:linear-gradient(135deg,var(--uae-green),var(--uae-red));-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask-composite:exclude;opacity:.25}
          .prod-card:hover{transform:translateY(-4px);box-shadow:0 16px 34px rgba(0,0,0,.12)}
          @media (max-width:1100px){.prod-grid{grid-template-columns:repeat(3,minmax(0,1fr))}}
          @media (max-width:800px){.prod-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}
          @media (max-width:520px){.prod-grid{grid-template-columns:1fr}}
        `}</style>

        {/* Unified products grid with image fallback */}
        <div className="prod-grid" aria-label="Emirates products gallery">
          {products.map((p, idx) => (
            <div key={idx} className="prod-card">
              <div className="prod-media">
                <img
                  src={p.img}
                  alt={t(p.name)}
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = fallbackImg;
                  }}
                />
              </div>
              <div className="prod-name">{t(p.name)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
